import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { Field } from 'formik';
import { FormControl } from '@mui/material';
import {setKlischeDetailsR} from '../../../../scenes/Orders/OrderSlice/OrderSlice';
import {useDispatch,useSelector} from 'react-redux';
import { ListItem } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useState } from 'react';
import { useEffect } from 'react';









export default function ControllableStates(props) {
  const{label,name,options,disabled,inputValues,...rest}=props;
  const [value, setValue] = React.useState(options?options[0]:'');
  const [inputValue, setInputValue] = React.useState(inputValues?inputValues:'');
  const [id,setId]=useState('')

  const sxStyle={
   
    color: '#fff',
    borderRadius: '4px',
    padding:'8px',
    textAlign: 'center',
    width:'100%',
    
     
    '& .muirtl-aqwd4r-MuiFormLabel-root-MuiInputLabel-root':{color:'yellow'}
  }


  const dispatch=useDispatch();
  useEffect(() => {
 
  }, [props])
  
 
  
  return (
    <Field name={name}>
    {
        ({form,field})=>{
          const {setFieldValue}=form;
       
return (
 <Autocomplete
       size='small'
       disabled={disabled}
        clearIcon={false}
        sx={sxStyle}
        options={options}
        defaultValue={""}
        getOptionLabel={(option) =>option? option.key: ''}
        isOptionEqualToValue={(option, value) => option.key === value.key}
        value={value || ""}
        onChange={(event, newValue) => {
          if(newValue){
            setValue(newValue?newValue:'');
          // setId(newValue.value)
          setFieldValue(name,newValue.value)
          }else{
            setValue('');
          // setId(newValue.value)
          setFieldValue(name,'')
          }
        }}
        inputValue={inputValue||""}
        onInputChange={(_, newInputValue) => {
          setInputValue(newInputValue);
         
        }}
        id={name}
        renderOption={(props, option) => (
          <ListItem sx={{fontFamily:'yekan',fontSize:'12px'}} {...props}>{option.key}&nbsp;&nbsp;&nbsp;</ListItem>
        )}
        
        renderInput={(params) => <TextField {...params} label={label} />}
      />
 
)
        }
    }
</Field>
    
     
   
  );
}

